import {IPosition, IWaypoint} from "@ui/leafletCustom/leafletPolyline/polylineDraggable/types";
import {getRandomString} from "@helpers/string";


const sqr = (x: number): number => x * x;

const distance = (a: [number, number], b: [number, number]): number => sqr(a[0] - b[0]) + sqr(a[1] - b[1]);

const closestOfSegment = (p: [number, number], v: [number, number], w: [number, number]): [number, number] => {
    const l2 = distance(v, w);
    if (l2 === 0) return v;
    const t =
        ((p[0] - v[0]) * (w[0] - v[0]) + (p[1] - v[1]) * (w[1] - v[1])) / l2;
    if (t < 0) return v;
    if (t > 1) return w;
    return [
        v[0] + t * (w[0] - v[0]),
        v[1] + t * (w[1] - v[1])
    ];
};

export const snapToPolyline = (latlng: [number, number], positions: [number, number][]): [number, number] | null => {
    let minDistance = Number.MAX_VALUE;
    let closest: [number, number] | null = null;
    for (let i = 0, len = positions.length - 1; i < len; ++i) {
        const p = closestOfSegment(latlng, positions[i], positions[i + 1]);
        const d = distance(latlng, p);
        if (d < minDistance) {
            closest = p;
            minDistance = d;
        }
    }
    return closest;
};

export const closestIndexOfPolyline = (latlng: [number, number], positions: [number, number][]): number | null => {
    let minDistance = Number.MAX_VALUE;
    let closestIndex: number | null = null;
    for (let i = 0, len = positions.length - 1; i < len; ++i) {
        const p = closestOfSegment(latlng, positions[i], positions[i + 1]);
        const d = distance(latlng, p);
        if (d < minDistance) {
            closestIndex = i;
            minDistance = d;
        }
    }
    return closestIndex;
};

export const toArrayLatLngPolyline = (latLng: { lat: number, lng: number }): [number, number] => [latLng.lat, latLng.lng];


export const addLastOrFirstPointOnTheIndex = (data: {
    pointIndex?: number
}[]) => {

    const itemsMapByPointIndex: Record<string, number> = {}
    data.forEach((item) => {
        if (!(item.pointIndex?.toString() in itemsMapByPointIndex)) {
            itemsMapByPointIndex[item.pointIndex] = 1
            return
        }
        itemsMapByPointIndex[item.pointIndex] = Number(itemsMapByPointIndex[item.pointIndex]) + 1
    })

    return data.map((item, index) => {
        const count = itemsMapByPointIndex[item.pointIndex];
        if (count < 3) {
            return {
                ...item,
                lastPointOnTheIndex: true,
            }
        }
        return item
    })
}

export const checkLastOrFirstPointOnTheIndex = ({
                                                    data,
                                                    waypoint
                                                }: {
    data: {
        pointIndex?: number,
        id: string
    }[],
    waypoint: IWaypoint
}): boolean => {
    const filtered = data.filter((item) => item.pointIndex === waypoint.pointIndex)
    return filtered.length <= 2

}

export const getInitialPosition = (initialPositions: {
    lat: number,
    lng: number,
    pointIndex?: number,
}[],): IPosition[] => {
    return initialPositions.map((item) => {
        return {
            id: getRandomString(),
            latLng: {
                lat: item.lat,
                lng: item.lng,
            },
            pointIndex: item.pointIndex ?? 0

        }
    })
}


export const getInitialState = ({
                                    positions,
                                    hasDraggableInitialPosition,
                                }: {
    positions: {
        lat: number,
        lng: number,
        pointIndex?: number,
    }[],
    hasDraggableInitialPosition?: boolean,
}): {
    initialPositions: IPosition[],
    initialWaypoints: IWaypoint[],

} => {
    if (!positions?.length) {
        return {
            initialWaypoints: [],
            initialPositions: []
        }
    }

    if (!hasDraggableInitialPosition) {
        return {
            initialWaypoints: [],
            initialPositions: getInitialPosition(positions)
        }
    }

    const initialWaypoints: IWaypoint[] = []
    const initialPositions: IPosition[] = []

    positions.forEach((item, index) => {
        const positionId = getRandomString()
        initialPositions.push({
            latLng: {
                lat: item.lat,
                lng: item.lng,
            },
            pointIndex: item.pointIndex ?? 0,
            id: positionId,
        })
        initialWaypoints.push({
            latLng: [item.lat, item.lng],
            id: getRandomString(),
            positionId,
            pointIndex: item.pointIndex ?? 0,
        })
    })
    return {
        initialWaypoints,
        initialPositions,
    }

}

export const convertLocalPosition = (position:IPosition[])=>{
    return position?.map((pos) => {
        return {
            lat: pos.latLng.lat,
            lng: pos.latLng.lng,
            pointIndex: pos.pointIndex,
        }
    })
}